export default "__VITE_ASSET__Bx$SS6U6__"